import * as React from 'react'

import { MessageModel } from 'app/models/messageModel'
import MessagePresenter from './MessagePresenter'

/**
 * Most między `messageStore` a wspólnym systemem toastów.
 *
 * Wcześniej montował tu własny `ToastProvider` z `react-toast-notifications` i własny
 * komponent toasta. Renderowaniem zajmuje się teraz `ToasterHost` z `@/lib/toasts`,
 * montowany raz w `app/index.tsx`, więc zostaje sam prezenter.
 */
export type MessageListenerDispatchProps = {}
export type MessageListenerOwnProps = {}
export type MessageListenerStateProps = {
  message: MessageModel
}

type MessageListenerProps = MessageListenerStateProps &
  MessageListenerDispatchProps &
  MessageListenerOwnProps

const MessageListener: React.FC<MessageListenerProps> = ({ message }) => (
  <MessagePresenter message={message} />
)

export default MessageListener
